import { Col, Row } from 'reactstrap';

import Input from 'common/components/form/inputs/Input';
import Select from 'common/components/form/inputs/Select';
import Checkbox from 'common/components/form/inputs/Checkbox';

const Body = ({ fields, changeField, selectField }) => {
  const options = [
    { label: 'Deck', value: 'deck' },
    { label: 'Electrical', value: 'electrical' },
    { label: 'Engine', value: 'engine' },
    { label: 'Steward', value: 'steward' }
  ];

  return (
    <div className="edit-rank">
      <Row className="no-gutters">
        <Col xs={12}>
          <Input label="NAME" onChange={changeField('name')} {...fields.name} />
        </Col>
        <Col xs={12}>
          <Input
            label="ABBREVIATION"
            onChange={changeField('abbreviation')}
            {...fields.abbreviation}
          />
        </Col>
        <Col xs={6}>
          <Select
            options={options}
            label="DEPARTMENT"
            isClearable
            onChange={selectField('department')}
            {...fields.department}
          />
        </Col>
      </Row>
      <Row>
        <Col>
          <Checkbox
            onChange={e => selectField('is_officer')(e.target.checked)}
            label={<span className="text-primary">Officer</span>}
            {...fields.is_officer}
          />
        </Col>
      </Row>
    </div>
  );
};

export default Body;
